import styled from 'styled-components';

const GoogleMapContainer = styled.div`
    display: block;
    height: 100%;
    width: 100%;
`;

export default GoogleMapContainer;
